/**
 * Canonical legal document version registry.
 *
 * This is the SINGLE SOURCE OF TRUTH for legal document versions
 * and reacceptMode across both frontend and edge-function runtimes.
 *
 * Frontend re-exports this via src/lib/legalVersions.ts.
 * Edge functions import directly via ../_shared/legal-versions.ts.
 *
 * See Invariant #59 in docs/INVARIANTS.md.
 */

export type LegalReacceptMode = 'material' | 'notice';

export const LEGAL_VERSIONS = {
  terms: { version: '2026-01-06', reacceptMode: 'notice' as LegalReacceptMode },
  privacy: { version: '2026-02-01', reacceptMode: 'notice' as LegalReacceptMode },
} as const;
